
import { Component, Vue } from 'vue-property-decorator';

import Form6ProcessHeader from "@/components/process/Form6/components/Form6ProcessHeader.vue";
import Form6StyleOfProceeding from "@/components/process/Form6/components/Form6StyleOfProceeding.vue";
import { form6StatusInfoType } from '@/types/Information/Form6';

@Component({
    components:{
        Form6ProcessHeader,        
        Form6StyleOfProceeding
    }
})
export default class FillForm6 extends Vue {

    stepsCompleted = {} as form6StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
